import api from './client';

// Transactions API
export const transactionsAPI = {
  getAll: (params) => api.get('/transactions', { params }),
  categorize: (id, category, { force = false } = {}) =>
    api.put(`/transactions/${id}/categorize?category=${category}${force ? '&force=true' : ''}`),
  // Reconcile a transaction with no invoice counterpart, recording a reason.
  reconcileManual: (id, reason) =>
    api.post(`/transactions/${id}/reconcile-manual`, { reason: reason }),
  // Monthly cash-flow, split by region (UK/France/Unassigned) and by
  // reconciliation state -- same entity/bank/category/date_range filters as
  // getAll, deliberately without is_reconciled (routes/transactions.py's
  // get_transactions_monthly_cashflow has no such param).
  getMonthlyCashflow: (params) => api.get('/transactions/monthly-cashflow', { params }),
};
